"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ClinicCalendarDayAvailabilitySchema () {
        return ClinicCalendarDayAvailabilitySchema;
    },
    get ClinicCalendarDayBranchSchema () {
        return ClinicCalendarDayBranchSchema;
    },
    get ClinicCalendarDayQuerySchema () {
        return ClinicCalendarDayQuerySchema;
    },
    get ClinicCalendarDayResponseSchema () {
        return ClinicCalendarDayResponseSchema;
    }
});
const _zod = require("zod");
const _time = require("./time");
const ClinicCalendarDayQuerySchema = _zod.z.object({
    date: _zod.z.iso.date({
        message: 'Date must be a calendar date (YYYY-MM-DD).'
    })
}).strict();
const TimeRangeSchema = _zod.z.object({
    start: _time.ClinicTimeSchema,
    end: _time.ClinicTimeSchema
}).strict();
const ClinicCalendarDayBranchSchema = _zod.z.object({
    branchId: _zod.z.string().uuid(),
    name: _zod.z.string().min(1),
    hours: _zod.z.object({
        isSet: _zod.z.boolean(),
        intervals: _zod.z.array(TimeRangeSchema)
    }).strict(),
    holiday: _zod.z.object({
        id: _zod.z.string().uuid(),
        reason: _zod.z.string().nullable()
    }).strict().nullable()
}).strict();
const ClinicCalendarDayAvailabilitySchema = _zod.z.object({
    userId: _zod.z.string().uuid(),
    branchId: _zod.z.string().uuid(),
    start: _time.ClinicTimeSchema,
    end: _time.ClinicTimeSchema,
    defaultDurationMinutes: _zod.z.number().int().min(5).max(120)
}).strict();
const ClinicCalendarDayResponseSchema = _zod.z.object({
    date: _zod.z.iso.date(),
    timezone: _zod.z.string().min(1),
    weekday: _time.IsoWeekdaySchema,
    branches: _zod.z.array(ClinicCalendarDayBranchSchema),
    availability: _zod.z.array(ClinicCalendarDayAvailabilitySchema),
    doctorsWithAvailability: _zod.z.array(_zod.z.string().uuid())
}).strict();
